import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import MoreOptionsIcon from 'dibs-vg/dist/react/more-options';

import styles from './SbRespCustomizable.scss';

export function SbRespCustomizable({ localizedPdpUrl }) {
    return (
        <div className={styles.container}>
            <a href={localizedPdpUrl} className={styles.link}>
                <MoreOptionsIcon className={styles.icon} />
                <FormattedMessage
                    id="sb.SbRespCustomizable.customizableLabel"
                    defaultMessage="More Options"
                />
            </a>
        </div>
    );
}

SbRespCustomizable.propTypes = {
    localizedPdpUrl: PropTypes.string.isRequired,
};
